import React from "react";
import { clearAdminToken, isAdminMode } from "../utils/adminAuth";

const AdminBanner = () => {
  if (!isAdminMode()) return null;

  const handleLogout = () => {
    clearAdminToken();
    window.location.reload();
  };

  return (
    <div
      style={{
        position: "sticky",
        top: 0,
        zIndex: 9999,
        background: "#856404",
        color: "#fff",
        padding: "8px 20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        fontSize: 14,
        fontWeight: 600,
      }}
    >
      <span>STAGING MODE — you are viewing staged (unpublished) content</span>
      <button
        onClick={handleLogout}
        style={{
          background: "rgba(255,255,255,0.2)",
          border: "1px solid rgba(255,255,255,0.5)",
          color: "#fff",
          padding: "4px 12px",
          borderRadius: 4,
          cursor: "pointer",
          fontWeight: 600,
          fontSize: 13,
        }}
      >
        Exit Staging
      </button>
    </div>
  );
};

export default AdminBanner;
